<template>
    <div>

        <h1 class="mt-4">Partners</h1>

        <div class="content-container">

            <div class="row g-6 mb-3">

                <div class="col-24 col-md-5 d-flex align-items-center">
                    <input
                        type="text"
                        class="form-control new-list-group-field"
                        placeholder="Sök namn, adress, mail etc"
                        v-model="settings.query.text"
                    >
                </div>

                <div class="col-24 col-md-3 d-flex align-items-center">
                    <select class="form-select new-list-group-field" v-model="settings.query.status">
                        <option :value="null">Status</option>
                        <option value="1">Prospect</option>
                        <option value="3">Inaktiv</option>
                        <option value="2">Aktiv</option>
                        <option value="5">Pausad</option>
                        <option value="4">Avslutad</option>
                        <option value="6">Avslutat prospect</option>
                        <option value="7">Inaktivt prospect</option>
                    </select>
                </div>

                <div class="col-24 col-md-4 d-flex align-items-center">
                    <select class="form-select new-list-group-field" v-model="settings.query.next_contact">
                        <option :value="null">Nästa kontakt</option>
                        <option v-for="user in options.users" :key="'nc_'+user.id" :value="user.id">
                            {{ user.name }}
                        </option>
                    </select>
                </div>

                <div class="col-24 col-md-9 d-flex pt-2 align-items-center gap-5 flex-wrap">

                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="settings.query.is_public" true-value="1" false-value="" id="check_is_public">
                        <label class="form-check-label" for="check_is_public">
                            Publicerad
                        </label>
                    </div>

                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="settings.query.contract_internal" true-value="1" false-value="" id="check_contract_internal">
                        <label class="form-check-label" for="check_contract_internal">
                            Aktiv mottagning
                        </label>
                    </div>

                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="settings.query.contract_external" true-value="1" false-value="" id="check_contract_external">
                        <label class="form-check-label" for="check_contract_external">
                            Aktiv företag
                        </label>
                    </div>

                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="settings.query.contract_pt" true-value="1" false-value="" id="check_contract_pt">
                        <label class="form-check-label" for="check_contract_pt">
                            Aktiv PT
                        </label>
                    </div>

                </div>

                <div class="col-24 col-md-3 d-flex justify-content-end align-items-center">
                    <button class="btn btn-primary btn-sm" @click="openExportModal()">Spara Excel
                        <div class="tooltip-label">Ladda ner en Excel-fil med mottagningar.</div>
                    </button>
                </div>

            </div>


            <list ref="list" :settings="settings" :query.sync="settings.query">
                <div slot="item-row" slot-scope="props">
                    <div class="row g-3">
                        <div class="col d-none d-md-flex col-md-1">
                            <span>{{ props.item.id }}</span>
                        </div>
                        <div class="col col-12 col-md-4">
                            <span>{{ props.item.name_person }}</span>
                        </div>
                        <div class="col d-none d-md-flex col-md-4">
                            <span>{{ props.item.name_clinic }}</span>
                        </div>
                        <div class="col d-none d-md-flex col-md-4">
                            <span>{{ props.item.address_title }}</span>
                        </div>
                        <div class="col d-none d-lg-flex col-lg-3">
                            <span>{{ props.item.meta_next_contact }}</span>
                        </div>
                        <div class="col d-none d-md-flex col-md-1">
                            <img v-if="props.item.is_public" class="check" src="/images/check.png" title="Publicerad i klippkortet">
                        </div>
                        <div class="col d-none d-md-flex col-md-1">
                            <img v-if="props.item.contract_internal" class="check" src="/images/check.png" title="Aktiv för mottagningsmassage">
                        </div>
                        <div class="col d-none d-md-flex col-md-1">
                            <img v-if="props.item.contract_external" class="check" src="/images/check.png" title="Aktiv för företagsmassage">
                        </div>
                        <div class="col d-none d-lg-flex col-lg-1">
                            <img v-if="props.item.contract_pt" class="check" src="/images/check.png" title="Aktiv för PT">
                        </div>
                        <div class="col d-none d-md-flex col-md-2">
                            <span class="badge badge-primary ms-0" v-if="props.item.status_label === 'Aktiv'">{{ props.item.status_label }}</span>
                            <span class="badge badge-warning ms-0" v-else-if="props.item.status_label === 'Prospekt'">{{ props.item.status_label }}</span>
                            <span class="badge badge-danger ms-0" v-else-if="props.item.status_label === 'Avslutad' || props.item.status_label === 'Avslutat prospekt'">{{ props.item.status_label }}</span>
                            <span class="badge badge-info ms-0" v-else>{{ props.item.status_label }}</span>
                        </div>
                        <div class="col col-12 col-md-2 d-flex justify-content-end">
                            <a :href="'/clinics/'+props.item.id">
                                <button class="btn btn-primary btn-sm">Hantera</button>
                            </a>
                        </div>
                    </div>
                </div>
            </list>

        </div>
    </div>
</template>

<script>
import lister from '../../../shared/mixins/lister'

export default {

    mixins: [
        lister
    ],

    props: {
        options: {
            required: true
        }
    },

    data () {
        return {
            settings: {
                url: '/clinics/list',
                query: {
                    text: '',
                    status: null,
                    is_public: '',
                    contract_internal: '',
                    contract_external: '',
                    contract_pt: '',
                    seen_prices: '',
                    prospect_product_area: null,
                    next_contact: null,
                },
                columns: [
                    { column: 'id', name: 'ID', class: 'col d-none d-md-flex col-md-1', sortable: true, default: true },
                    { column: 'name_person', name: 'Personnamn', class: 'col col-12 col-md-4', sortable: true },
                    { column: 'name_clinic', name: 'Mottagning', class: 'col d-none d-md-flex col-md-4', sortable: true },
                    { column: 'address_title', name: 'Adress', class: 'col d-none d-md-flex col-md-4', sortable: true },
                    { column: 'meta_next_contact', name: 'Nästa kontakt', class: 'col d-none d-lg-flex col-lg-3', sortable: true },
                    { column: 'is_public', name: 'Publ.', class: 'col d-none d-md-flex col-md-1', sortable: true },
                    { column: 'contract_internal', name: 'Mott.', class: 'col d-none d-md-flex col-md-1', sortable: true },
                    { column: 'contract_external', name: 'För.', class: 'col d-none d-md-flex col-md-1', sortable: true },
                    { column: 'contract_pt', name: 'PT', class: 'col d-none d-lg-flex col-lg-1', sortable: true },
                    { column: 'status_label', name: 'Status', class: 'col d-none d-md-flex col-md-2', sortable: false },
                ],
                bulk_actions: [],
                export_fields: [
                    { column: 'id',                                         name: 'ID' },
                    { column: 'name_person',                                name: 'Personnamn' },
                    { column: 'name_clinic',                                name: 'Mottagningsnamn' },
                    { column: 'card_name_person',                           name: 'Personnamn som visas i klippkort' },
                    { column: 'card_name_clinic',                           name: 'Mottagningsnamn som visas i klippkort' },
                    { column: 'name_company_contact',                       name: 'Kontaktperson / Firmatecknare' },
                    { column: 'name_company',                               name: 'Företagsnamn' },
                    { column: 'group',                                      name: 'Område' },
                    { column: 'org_number',                                 name: 'Organisationsnummer' },
                    { column: 'meta_next_contact',                          name: 'Datum för nästa kontakt' },
                    { column: 'address.street',                             name: 'Mottagning gata' },
                    { column: 'address.zip',                                name: 'Mottagning postnr' },
                    { column: 'address.city',                               name: 'Mottagning postort' },
                    { column: 'address_home',                               name: 'Postadress' },
                    { column: 'address_company',                            name: 'Företagsadress' },
                    { column: 'billing_phone',                              name: 'Telefon för kontakt & fakturering' },
                    { column: 'public_phone',                               name: 'Telefon som kund ser' },
                    { column: 'email',                                      name: 'E-post för inloggning, kontakt & fakturering' },
                    { column: 'public_email',                               name: 'Epost som kund ser' },
                    { column: 'booking_info',                               name: 'Information om bokning' },
                    { column: 'booking_instructions',                       name: 'Övrig information' },
                    { column: 'booking_directions',                         name: 'Vägbeskrivning' },
                    { column: 'booking_link',                               name: 'Bokningslänk' },
                    { column: 'website_link',                               name: 'Hemsida' },
                    { column: 'facebook_link',                              name: 'Facebook' },
                    { column: 'hours_weekdays',                             name: 'Öppettider' },
                    { column: 'paymentBankAccount',                         name: 'Kontouppgifter bank' },
                    { column: 'paymentBG',                                  name: 'Kontouppgifter bankgiro' },
                    { column: 'paymentPG',                                  name: 'Kontouppgifter plusgiro' },
                    { column: 'timezynkID',                                 name: 'Timezynk ID' },
                    { column: 'checkbox_25min',                             name: 'Utför 25min',                                yes_no: true },
                    { column: 'checkbox_40min',                             name: 'Utför 40min',                                yes_no: true },
                    { column: 'checkbox_50min',                             name: 'Utför 50min',                                yes_no: true },
                    { column: 'checkbox_60min',                             name: 'Utför 60min',                                yes_no: true },
                    { column: 'payment25min3011',                           name: '4011 25 min' },
                    { column: 'payment40min3011',                           name: '4011 40 min' },
                    { column: 'payment60min3011',                           name: '4010 60 min' },
                    { column: 'payment25min3012',                           name: '4012 25 min' },
                    { column: 'payment40min3012',                           name: '4012 40 min' },
                    { column: 'payment50min3012',                           name: '4012 50 min' },
                    { column: 'payment60min3310',                           name: '4013 60 min (PT)' },
                    { column: 'prospect_product_area',                      name: 'Prospect tjänsteområde',                     func: 'getProspectProductAreas' },
                    { column: 'checkbox_own_clinic_join',                   name: 'Är intresserad att ansluta sin mottagning',  func: 'getMetaValueForKey', yes_no: true },
                    { column: 'checkbox_intrest_in_external',               name: 'Är intresserad av företagsuppdrag',          func: 'getMetaValueForKey', yes_no: true },
                    { column: 'signatureKeyInternal',                       name: 'Signatur mottagning' },
                    { column: 'signatureKeyExternal',                       name: 'Signatur företag' },
                    { column: 'region_manager',                             name: 'Regionansvarig' },
                    { column: 'contact_manager',                            name: 'Kontaktansvarig' },
                    { column: 'checkbox_letter_sent',                       name: 'Skickat startkit',                           func: 'getMetaValueForKey', yes_no: true },
                    { column: 'date_connected_internal',                    name: 'Anslutningsdag mottagning',                  func: 'getMetaValueForKey' },
                    { column: 'date_connected_external',                    name: 'Anslutningsdag företag',                     func: 'getMetaValueForKey' },
                    { column: 'date_connected_pt',                          name: 'Anslutningsdag PT',                          func: 'getMetaValueForKey' },
                    { column: 'date_disconnected_internal',                 name: 'Avslutningsdatum mottagning',                func: 'getMetaValueForKey' },
                    { column: 'date_disconnected_external',                 name: 'Avslutningsdatum företag',                   func: 'getMetaValueForKey' },
                    { column: 'date_disconnected_pt',                       name: 'Avslutningsdatum PT',                        func: 'getMetaValueForKey' },
                    { column: 'feedback_average_1',                         name: 'Kundenkät - Bemötandet' },
                    { column: 'feedback_average_2',                         name: 'Kundenkät - Behandlingen' },
                    { column: 'feedback_average_3',                         name: 'Kundenkät - Atmosfären' },
                    { column: 'feedback_average_4',                         name: 'Kundenkät - Hitta lokalen' },
                    { column: 'feedback_average_5',                         name: 'Kundenkät - Helheten' },
                    { column: 'feedback_num_responded',                     name: 'Kundenkät - Antal svar' },
                    { column: 'signature_key_qr_code_string',               name: 'QR-kod - Signatur',                          func: 'getSignatureKeyString' },
                    { column: 'signature_key_qr_code_url',                  name: 'QR-kod - URL',                               func: 'getSignatureKeyQrCodeUrl' },
                    { column: 'checkbox_benify_updated',                    name: 'Upplagd på Benify',                          func: 'getMetaValueForKey', yes_no: true },
                    { column: 'checkbox_epassi_updated',                    name: 'Upplagd på ePassi',                          func: 'getMetaValueForKey', yes_no: true },
                    { column: 'checkbox_soderberg_updated',                 name: 'Upplagd på Söderberg & Partner',             func: 'getMetaValueForKey', yes_no: true },
                    { column: 'checkbox_wellnet_updated',                   name: 'Upplagd på Wellnet',                         func: 'getMetaValueForKey', yes_no: true },
                    { column: 'checkbox_benefits_updated',                  name: 'Upplagd på Benefits',                        func: 'getMetaValueForKey', yes_no: true },
                    { column: 'checkbox_edenred_updated',                   name: 'Upplagd på Edenred',                         func: 'getMetaValueForKey', yes_no: true },
                    { column: 'booking_presentation',                       name: 'Publicerad presentation' },
                    { column: 'has_presentation_portrait',                  name: 'Publicerat porträttsfoto',                   func: 'hasPresentationPortrait', yes_no: true },
                    { column: 'has_presentation_location',                  name: 'Publicerat mottagningsfoto',                 func: 'hasPresentationLocation', yes_no: true },
                    { column: 'clinic_submitted_approved_at',               name: 'Senast godkända uppgifter' },
                    { column: 'checkbox_newsletter_opt_out',                name: 'Vill ej ta emot utskick',                    func: 'getMetaValueForKey', yes_no: true },
                    { column: 'education',                                  name: 'Utbildning och erfarenhet, fritext' },
                    { column: 'checkbox_diploma_massage',                   name: 'Diplomerad massör',                          func: 'getMetaValueForKey', yes_no: true },
                    { column: 'checkbox_diploma_massage_therapist',         name: 'Diplomerad massageterapeut',                 func: 'getMetaValueForKey', yes_no: true },
                    { column: 'checkbox_diploma_massage_therapist_medical', name: 'Diplomerad medicinsk massageterapeut',       func: 'getMetaValueForKey', yes_no: true },
                    { column: 'checkbox_certified_bsm',                     name: 'Certifierad massör enlig BSM',               func: 'getMetaValueForKey', yes_no: true },
                    { column: 'text_experience_misc',                       name: 'Erfarenhet',                                 func: 'getMetaValueForKey' },
                    { column: 'textarea_supplementary_pt_focus',            name: 'Inriktning PT',                              func: 'getMetaValueForKey' },
                    { column: 'checkbox_pt_online_sessions',                name: 'Har personlig träning online?',              func: 'getMetaValueForKey', yes_no: true },
                    { column: 'checkbox_multiple_clinics',                  name: 'Mottagning med anställda',                   func: 'getMetaValueForKey', yes_no: true },
                ]
            }
        }
    }
}
</script>
